import { Component, OnInit } from '@angular/core';
import {
  AvlaGenericComponent,
  MessageService,
  I18nService,
  InfoMessageDTO,
} from 'shared-angular-components-avla';
import { AuthService, AvlaRestClientService } from 'base-angular-avla';
import { Router } from '@angular/router';

declare var $: any;

@Component({
  selector: 'dev-component',
  templateUrl: './dev.component.html',
  providers: [I18nService],
})
export class DevComponent extends AvlaGenericComponent implements OnInit {
  constructor(
    protected restClientService: AvlaRestClientService,
    protected messageService: MessageService,
    protected router: Router,
    protected authService: AuthService,
    protected i18n: I18nService
  ) {
    super(restClientService, messageService, router, authService, i18n);
  }
  ngOnInit() {
    if (this.isDevelop) {
      setTimeout(() => {
        this.showMesaggeDevelop();
      }, 2500);
    }
  }
  public get isDevelop() {
    if (window && window['serverApiUrl'].indexOf('dev_SAGR') > -1) {
      return true;
    }
    return false;
  }
  private helpShowed = false;

  private static get TIME_SECONDS_SHOW_HELP() {
    return 10;
  }

  public showMesaggeDevelop() {
    if (this.helpShowed) {
      return;
    }
    this.messageService.announcedMessage(
      new InfoMessageDTO(
        'warning',
        '<h5>ADVERTENCIA</h5><br>' +
          '<b>Estás apuntando tus servicios a desarrollo, si usted no es desarrollador por favor contactar urgente a 687</b>',
        DevComponent.TIME_SECONDS_SHOW_HELP * 1000
      )
    );

    this.helpShowed = true;
    setTimeout(() => {
      this.helpShowed = false;
    }, DevComponent.TIME_SECONDS_SHOW_HELP * 1000);
  }
}
